import React from "react";

import { EmployeeRoutes } from "components/Employees/EmployeeRoutes";
import { MemberRoutes } from "components/Members/MemberRoutes";

import { accountGroupRoutes } from "component/AccountGroup/accountGroupRoutes";
import { accountLedgerRoutes } from "component/AccountLedger/accountLedgerRoutes";
import { balanceSheetRoutes } from "component/BalanceSheet/balanceSheetRoutes";
import { bankRoutes } from "component/Banks/bankRoutes";
import { branchRoutes } from "component/Branches/branchRoutes";
import { categoryRoutes } from "component/Categories/categoryRoutes";
import { customersRoutes } from "component/Customers/CustomerRoutes";
import { dietPlanPackageRoutes } from "component/DietPlanPackages/dietPlanPackageRoutes";
import { employeeRoutes } from "component/Employees/employeeRoutes";
import { expenseRoutes } from "component/Expense/expenseRoutes";
import { foodRoutes } from "component/Foods/foodRoutes";
import { groupRoutes } from "component/Group/groupRoutes";
import { invoiceReceiptRoutes } from "component/InvoiceReceipts/invoiceReceiptsRoutes";
import { invoiceRoutes } from "component/Invoices/invoiceRoutes";
import { journalEntryRoutes } from "component/JournalEntry/journalEntryRoutes";
import { linkingAccountRoutes } from "component/LinkingAccount/linkAccountRoutes";
import { lockerRoutes } from "component/Locker/lockerRoutes";
import { mealRoutes } from "component/MealTypes/mealRoutes";
import { memberShipFreezingDateRoutes } from "component/MemberShipFreezingRequest/memberShipFreezingDateRoutes";
import { membershipPackageRoutes } from "component/MembershipPackages/membershipPackageRoutes";
import { nutritionPlanRoutes } from "component/NutritionPlan/nutritionPlanRoutes";
import { productRoutes } from "component/Products/productRoutes";
import { profitAndLossRoutes } from "component/ProfitAndLoss/profitAndLossRoutes";
import { purchaseOrderRoutes } from "component/PurchaseOrders/purchaseOrderRoutes";
import { purchaseReceiptRoutes } from "component/PurchaseReceipts/purchaseReceiptRoutes";
import { purchaseReturnRoutes } from "component/PurchaseReturns/purchaseReturnRoutes";
import { salesReturnRoutes } from "component/SalesReturns/salesReturnRoutes";
import { sessionRoutes } from "component/Session/sessionRoutes";
import { sessionWorkoutRoutes } from "component/SessionWorkout/sessionWorkoutRoutes";
import { supplierRoutes } from "component/Suppliers/supplierRoutes";
import { workoutRoutes } from "component/WorkOut/workoutRoutes";
import { workoutCategoriesRoutes } from "component/WorkoutCategories/workoutCategoriesRoutes";
import { classRoutes } from "component/classes/classRoutes";
import { trainingPackageRoutes } from "component/personalTrainingPackage/trainingPackageRoutes";
import { userRoutes } from "component/users/userRoutes";
// import { dietPlanPackageBookingsRoutes } from "component/DietPlanPackageBookings/dietPlanPackageRoutes";
// import { personalTrainingPackageBookingRoutes } from "component/PersonalTrainingPackageBookings/personalTrainingPackageBookingRoutes";
// import { membershipPackageBookingRoutes } from "component/MembershipPackageBookings/membershipPackageBookingRoutes";
import { classTrainerAttendanceRoutes } from "component/ClassAttendance/classAttendanceRoutes";
import { classMemberAttendanceRoutes } from "component/ClassMemberAttendance/memberAttendanceRoutes";
import { classWorkoutRoutes } from "component/ClassWorkouts/classWorkoutRoutes";
import { coreDataRoutes } from "component/CoreData/coreDataRoutes";
import { employeeBankRoutes } from "component/EmployeeBankDetails/employeeBankDetailsRoutes";
import { employeeBonusRoutes } from "component/EmployeeBonus/employeeBonusRoutes";
import { employeeDeductionRoutes } from "component/EmployeeDeduction/employeeDeductionRoutes";
import { employeeDocumentsRoutes } from "component/EmployeeDocument/employeeDocumentRoutes";
import { employeeFamilyRoutes } from "component/EmployeeFamilyDetails/employeeFamilyDetailsRoutes";
import { employeeLeaveRoutes } from "component/EmployeeLeave/employeeLeaveRoutes";
import { employeeLoanRoutes } from "component/EmployeeLoan/employeeLoanRoutes";
import { employeeSettlementRoutes } from "component/EmployeeSettlement/employeeSettlementRoutes";
import { deductionTypeRoutes } from "component/HRMSDeductionType/deductionTypeRoutes";
import { departmentRoutes } from "component/HRMSDepartment/departmentRoutes";
import { leaveTypeRoutes } from "component/HRMSLeaveType/leaveTypeRoutes";
import { maritalStatusRoutes } from "component/HRMSMaritalStatus/maritalStatusRoutes";
import { lockerMemberRoutes } from "component/LockerMember/memberLockerRoutes";
import { memberAttendanceRoutes } from "component/MemberAttendances/memberAttendanceRoutes";
import { memberWorkoutRoutes } from "component/MemberWorkouts/memberworkoutRoutes";
import { notificationRoutes } from "component/Notification/notificationRoutes";
import { orderRoutes } from "component/Orders/orderRoutes";
import { employeeOvertimeRoutes } from "component/OverTime/overtimeRoutes";
import { postponeClassRoute } from "component/PostponeClass/postponeClassRoutes";
import { classScheduledRoutes } from "component/ScheduleClasses/classScheduledRoutes";
import { sessionAttendanceRoutes } from "component/SessionAttendances/sessionAttendanceRoutes";
import { trackNutritionPlanRoutes } from "component/TrackNutritionPlan/trackNutritionPlanRoutes";
import { voucherDetailsRoutes } from "component/VoucherDetails/voucherDetailsRoutes";
import { employeeAttendanceRoutes } from "component/employeeAttendances/employeeAttendanceRoutes";
// import { BodyMeasurementTracksRoutes } from "component/BodyMeasurementTracks/BodyMeasurementTracksRoutes";
import { NotificationTemplateRoutes } from "component/NotificationTemplate/NotificationTemplateRoutes";
import { BMITracksRoutes } from "components/BMITracks/BMITracksRoutes";
import { BodyMeasurementTracksRoutes } from "components/BodyMeasurementTracks/BodyMeasurementTracksRoutes";
import { BookedClassesRoute } from "components/BookedClasses/BookedClassesRoute";
import { BusinessCategoriesRoutes } from "components/BusinessCategories/BusinessCategoriesRoutes";
import { BusinessPromoteRoutes } from "components/BusinessPromoteList/BusinessPromoteRoutes";
import { ClassWorkoutRoutes } from "components/ClassWorkouts/ClassWorkoutRoutes";
import { CompanyRoutes } from "components/Company/CompanyRoutes";
import { DietPlanPackageBookingRoute } from "components/DietPlanPackageBooking/DietPlanPackageBookingRoute";
import { EventParticipantsRoutes } from "components/EventParticipants/eventParticipantsRoute";
import { GenderRoutes } from "components/Genders/GenderRoutes";
import { LoyaltyPointsTracksRoutes } from "components/LoyaltyPointsTracks/LoyaltyPointsTracksRoutes";
import { MemberShipPackageBookingRoute } from "components/MemberShipPackageBooking/MemberShipPackageBookingRoute";
import { OpenDoorRequestsRoute } from "components/OpenDoorRequests/OpenDoorRequestRoute";
import { PersonalTrainingBookingsRoute } from "components/PersonalTrainingBookings/PersonalTrainingBookingsRoutes";
import ProductUom from "components/ProductUom";
import { ProfileVerificationRoute } from "components/ProfileVerification/ProfileVerificationRoute";
import { ReportsRoutes } from "components/Reports/ReportsRoutes";
import { RoomRoutes } from "components/Room/RoomRoutes";
import { ScheduleClassesRoutes } from "components/ScheduleClasses/ScheduleClassesRoutes";
import { SportsAndEventsRoutes } from "components/SportsAndEvents/SportsAndEventsRoutes";
import { WaterInTakeRoutes } from "components/WaterInTake/WaterInTakeRoutes";
import InvoiceReceipt from "components/InvoiceReceipt";
import InvoiceReceiptDetails from "components/InvoiceReceipt/InvoiceReceiptDetail";
import InvoiceReceiptView from "components/BookingFeatures/Template/InvoiceReceipt";

// const Dashboard = React.lazy(() => import("./component/dashboard"));
const Log = React.lazy(() => import("./component/log"));
// const Members = React.lazy(() => import("./component/Members"));
const Attendances = React.lazy(() => import("./component/GymAttendances"));
// const EmployeeAttendances = React.lazy(() =>
//   import("./component/employeeAttendances")
// );
const EmployeesAttendances = React.lazy(() =>
  import("./components/EmployeesAttendances")
);
const DietPlanPackages = React.lazy(() =>
  import("./component/DietPlanPackages")
);
const PersonalTrainingPackage = React.lazy(() =>
  import("./component/personalTrainingPackage")
);
const PackageBookings = React.lazy(() => import("./component/packageBooking"));

// const PersonalTrainingBookings = React.lazy(() =>
//   import("./component/personalTrainingPackage")
// );
const PaymentHistory = React.lazy(() => import("./component/paymentHistory"));
const Discount = React.lazy(() => import("./component/discount"));
const WorkOut = React.lazy(() => import("./component/WorkOut"));
// const Classes = React.lazy(() => import("./component/classes"));
// const ScheduleClasses = React.lazy(() => import("./component/ScheduleClasses"));
const BookingClasses = React.lazy(() => import("./component/bookingClasses"));
const Foods = React.lazy(() => import("./component/Foods"));
const NutritionPlan = React.lazy(() => import("./component/NutritionPlan"));
const TrackNutritionPlan = React.lazy(() =>
  import("./component/TrackNutritionPlan")
);
const AllBodyMeasurementTracks = React.lazy(() =>
  import("./component/BodyMeasurementTracks")
);
const DietPlanPackageBookings = React.lazy(() =>
  import("./component/DietPlanPackageBookings")
);
const PersonalTrainingPackageBookings = React.lazy(() =>
  import("./component/PersonalTrainingPackageBookings")
);
const Locker = React.lazy(() => import("./component/Locker"));
const LockerMember = React.lazy(() => import("./component/LockerMember"));
const LockerTrack = React.lazy(() => import("./component/LockerTrack"));
const Session = React.lazy(() => import("./component/Session"));
const MemberAttendances = React.lazy(() =>
  import("./components/MemberAttendance")
);
const SessionAttendances = React.lazy(() =>
  import("./component/SessionAttendances")
);
const TrainerClasses = React.lazy(() => import("./component/TrainerClasses"));
const MembershipPackageBookings = React.lazy(() =>
  import("./component/MembershipPackageBookings")
);
const MealTypes = React.lazy(() => import("./component/MealTypes"));
const Suppliers = React.lazy(() => import("./component/Suppliers"));
const Notification = React.lazy(() => import("./component/Notification"));
const PurchaseOrders = React.lazy(() => import("./component/PurchaseOrders"));
const PurchaseReturns = React.lazy(() => import("./component/PurchaseReturns"));
const PurchaseReceipts = React.lazy(() =>
  import("./component/PurchaseReceipts")
);
const Invoices = React.lazy(() => import("./component/Invoices"));
const Receipts = React.lazy(() => import("./component/InvoiceReceipts"));
const SalesReturns = React.lazy(() => import("./component/SalesReturns"));
const UOMList = React.lazy(() => import("./component/UnitOfMeasure"));
const CreateProductUom = React.lazy(() =>
  import("./component/UnitOfMeasure/CreateUnitOfMeasure")
);
const Products = React.lazy(() => import("./component/Products"));
const ProductsCreate = React.lazy(() =>
  import("./component/Products/CreateProduct")
);
const Categories = React.lazy(() => import("./component/Categories"));
const ProductsWithUOMStock = React.lazy(() =>
  import("./component/ProductsWithUOMStock")
);
const Group = React.lazy(() => import("./component/Group"));
const AccountGroup = React.lazy(() => import("./component/AccountGroup"));
const AccountLedger = React.lazy(() => import("./component/AccountLedger"));
const BankReconciliationReminderPayment = React.lazy(() =>
  import("./component/BankReconciliationReminderPayment")
);
const BankReconciliationReminderReceipt = React.lazy(() =>
  import("./component/BankReconciliationReminderReceipt")
);
const PaymentVoucher = React.lazy(() => import("./component/PaymentVoucher"));
const ReceiptVoucher = React.lazy(() => import("./component/ReceiptVoucher"));
const PaymentRegister = React.lazy(() => import("./component/PaymentRegister"));
const ReceiptRegister = React.lazy(() => import("./component/ReceiptRegister"));
const AccountLedgerReport = React.lazy(() =>
  import("./component/AccountLedgerReport")
);
const GroupReport = React.lazy(() => import("./component/GroupReport"));
const VoucherDetail = React.lazy(() => import("./component/VoucherDetails"));
const ProfitAndLoss = React.lazy(() => import("./component/ProfitAndLoss"));
const ScheduledForProfitAndLoss = React.lazy(() =>
  import("./component/ScheduledProfitAndLoss")
);
const BalanceSheet = React.lazy(() => import("./component/BalanceSheet"));
const ScheduledForBalanceSheet = React.lazy(() =>
  import("./component/ScheduledForBalanceSheet")
);
const TrialBalance = React.lazy(() => import("./component/TrialBalance"));
const ScheduledTrialBalance = React.lazy(() =>
  import("./component/ScheduledTrialBalance")
);
const Department = React.lazy(() => import("./component/HRMSDepartment"));
const MaritalStatus = React.lazy(() => import("./component/HRMSMaritalStatus"));
const DeductionType = React.lazy(() => import("./component/HRMSDeductionType"));
const LeaveType = React.lazy(() => import("./component/HRMSLeaveType"));
const EmployeeBankDetails = React.lazy(() =>
  import("./component/EmployeeBankDetails")
);
const EmployeeFamilyDetails = React.lazy(() =>
  import("./component/EmployeeFamilyDetails")
);
const OverTime = React.lazy(() => import("./component/OverTime"));
const EmployeeSettlement = React.lazy(() =>
  import("./component/EmployeeSettlement")
);
const EmployeeDeduction = React.lazy(() =>
  import("./component/EmployeeDeduction")
);
const Leave = React.lazy(() => import("./component/EmployeeLeave"));
const Resign = React.lazy(() => import("./component/Resign"));
const Loan = React.lazy(() => import("./component/EmployeeLoan"));
const EmployeeDocuments = React.lazy(() =>
  import("./component/EmployeeDocument")
);
const SalaryStatement = React.lazy(() => import("./component/SalaryStatement"));
const EmployeeCommissions = React.lazy(() =>
  import("./component/EmployeeCommission")
);
const LinkingAccount = React.lazy(() => import("./component/LinkingAccount"));
const JournalVoucher = React.lazy(() => import("./component/JournalVouchers"));
const Bank = React.lazy(() => import("./component/Banks"));
const Customers = React.lazy(() => import("./component/Customers"));
const Terms = React.lazy(() => import("./component/Setting/Pages/Terms"));
const Policy = React.lazy(() => import("./component/Setting/Pages/Policy"));
const AboutUs = React.lazy(() => import("./component/Setting/Pages/AboutUs"));

const Dashboard = React.lazy(() => import("./components/Dashboard"));
const AccessControl = React.lazy(() => import("./components/AccessControl"));

export const AppRoutes = [
  { name: "Dashboard", path: "/admin/dashboard", element: <Dashboard /> },
  // {
  //   path: "/admin/dietPlanPackages",
  //   name: "DietPlanPackages",
  //   element: <DietPlanPackages />,
  // },
  // {
  //   path: "/admin/personalTrainingPackage",
  //   name: "PersonalTrainingPackage",
  //   element: <PersonalTrainingPackage />,
  // },
  // {
  //   path: "/admin/membershipPackages",
  //   name: "MembershipPackages",
  //   element: <MembershipPackage />,
  // },
  ...MemberRoutes,
  ...EmployeeRoutes,
  ...DietPlanPackageBookingRoute,
  ...MemberShipPackageBookingRoute,
  ...PersonalTrainingBookingsRoute,
  ...GenderRoutes,
  ...BookedClassesRoute,
  ...BodyMeasurementTracksRoutes,
  ...RoomRoutes,
  ...ClassWorkoutRoutes,
  ...ScheduleClassesRoutes,
  ...OpenDoorRequestsRoute,
  ...ReportsRoutes,
  ...SportsAndEventsRoutes,
  ...BMITracksRoutes,
  ...WaterInTakeRoutes,
  ...LoyaltyPointsTracksRoutes,
  ...CompanyRoutes,
  ...EventParticipantsRoutes,
  ...BusinessCategoriesRoutes,
  ...BusinessPromoteRoutes,
  ...ProfileVerificationRoute,
  { path: "/admin/log", name: "Log", element: <Log /> },

  { path: "/admin/setting", name: "setting", element: <Terms /> },
  {
    path: "/admin/setting/accessControl",
    name: "AccessControl",
    element: <AccessControl />,
  },
  {
    path: "/admin/setting/terms",
    name: "setting",
    element: <Terms />,
  },
  {
    path: "/admin/setting/privacy-policy",

    name: "Privacy-Policy",
    element: <Policy />,
  },

  {
    path: "/admin/setting/about-us",

    name: "About-Us",
    element: <AboutUs />,
  },

  {
    path: "/admin/attendances",

    name: "Attendances",
    element: <Attendances />,
  },

  {
    path: "/admin/employeeAttendances",

    name: "EmployeeAttendances",
    element: <EmployeesAttendances />,
  },

  // {
  //   path: "/admin/dietPlanPackages",

  //   name: "DietPlanPackages",
  //   element: <DietPlanPackages />,
  // },

  // {
  //   path: "/admin/personalTrainingPackage",

  //   name: "PersonalTrainingPackage",
  //   element: <PersonalTrainingPackage />,
  // },
  // {
  //   path: "/admin/membershipPackages",

  //   name: "MembershipPackages",
  //   element: <MembershipPackages />,
  // },

  {
    path: "/admin/packageBookings",

    name: "PackageBookings",
    element: <PackageBookings />,
  },

  // {
  // 	path: "/admin/dietPlanPackageBookings",
  //
  // 	name: "DietPlanPackageBookings",
  // 	element: DietPlanPackageBookings,
  // },

  {
    path: "/admin/paymentHistory",
    name: "PaymentHistory",
    element: <PaymentHistory />,
  },

  {
    path: "/admin/discount",
    name: "Discount",
    element: <Discount />,
  },

  // { path: "/admin/workOut", name: "WorkOut", element: <WorkOut /> },

  // { path: "/admin/classes",  name: "Classes", element: Classes },

  // {
  // 	path: "/admin/scheduleClasses",
  //
  // 	name: "ScheduleClasses",
  // 	element: ScheduleClasses,
  // },

  {
    path: "/admin/bookingClasses",

    name: "BookingClasses",
    element: <BookingClasses />,
  },

  // { path: "/admin/foods", name: "Foods", element: <Foods /> },

  {
    path: "/admin/nutritionPlan",

    name: "NutritionPlan",
    element: <NutritionPlan />,
  },

  {
    path: "/admin/trackNutritionPlan",

    name: "TrackNutritionPlan",
    element: <TrackNutritionPlan />,
  },

  // {
  //   path: "/admin/allBodyMeasurementTracks",

  //   name: "AllBodyMeasurementTracks",
  //   element: <AllBodyMeasurementTracks />,
  // },

  { path: "/admin/locker", name: "Locker", element: <Locker /> },

  {
    path: "/admin/lockerMember",

    name: "LockerMember",
    element: <LockerMember />,
  },
  {
    path: "/admin/lockerTrack",

    name: "LockerTrack",
    element: <LockerTrack />,
  },

  { path: "/admin/session", name: "Session", element: <Session /> },

  {
    path: "/admin/memberAttendances",

    name: "MemberAttendances",
    element: <MemberAttendances />,
  },

  // {
  // 	path: "/admin/sessionAttendances",
  //
  // 	name: "SessionAttendances",
  // 	element: SessionAttendances,
  // },

  {
    path: "/admin/trainerClasses",

    name: "TrainerClasses",
    element: <TrainerClasses />,
  },
  // {
  // 	path: "/admin/personalTrainingPackageBookings",
  //
  // 	name: "personalTrainingPackageBookings",
  // 	element: PersonalTrainingPackageBookings,
  // },
  // {
  // 	path: "/admin/membershipPackageBookings",
  //
  // 	name: "MembershipPackageBookings",
  // 	element: MembershipPackageBookings,
  // },
  // {
  // 	path: "/admin/mealTypes",
  //
  // 	name: "MealTypes",
  // 	element: MealTypes,
  // },
  // {
  // 	path: "/admin/suppliers",
  //
  // 	name: "Suppliers",
  // 	element: Suppliers,
  // },
  // {
  // 	path: "/admin/notification",
  //
  // 	name: "Notification",
  // 	element: Notification,
  // },
  // {
  // 	path: "/admin/purchaseOrders",
  //
  // 	name: "PurchaseOrders",
  // 	element: PurchaseOrders,
  // },
  {
    path: "/admin/purchaseReturns",

    name: "PurchaseReturns",
    element: <PurchaseReturns />,
  },
  {
    path: "/admin/purchaseReceipts",

    name: "PurchaseReceipts",
    element: <PurchaseReceipts />,
  },
  // {
  // 	path: "/admin/salesInvoices",
  //
  // 	name: "Invoices",
  // 	element: Invoices,
  // },
  {
    path: "/admin/salesReceipts",

    name: "Receipts",
    element: <Receipts />,
  },
  {
    path: "/admin/salesReturns",

    name: "SalesReturns",
    element: <SalesReturns />,
  },
  // {
  // 	path: "/admin/customers",
  //
  // 	name: "Customers",
  // 	element: Customers,
  // },
  {
    path: "/admin/UnitOfMeasure",

    name: "UnitOfMeasure",
    element: <ProductUom />,
  },
  {
    path: "/admin/UnitOfMeasure/create",

    name: "Create Product UnitOfMeasure",
    element: <CreateProductUom />,
  },
  {
    path: "/admin/UnitOfMeasure/update/:id",

    name: "Update Product UnitOfMeasure",
    element: <CreateProductUom />,
  },
  // {
  // 	path: "/admin/products",
  //
  // 	name: "Products",
  // 	element: Products,
  // },
  // {
  // 	path: "/admin/products/(create|update)/:id?",
  //
  // 	name: "Products Create",
  // 	element: ProductsCreate,
  // },
  // {
  // 	path: "/admin/categories",
  //
  // 	name: "Categories",
  // 	element: Categories,
  // },
  {
    path: "/admin/productsWithUOMStock",

    name: "ProductsWithUOMStock",
    element: <ProductsWithUOMStock />,
  },
  // {
  //   path: "/admin/bank",

  //   name: "Bank",
  //   element: <Bank />,
  // },
  {
    path: "/admin/group",

    name: "Group",
    element: <Group />,
  },
  {
    path: "/admin/accountGroup",

    name: "AccountGroup",
    element: <AccountGroup />,
  },
  {
    path: "/admin/accountLedger",

    name: "AccountLedger",
    element: <AccountLedger />,
  },
  {
    path: "/admin/bankReconciliationReminderPayment",

    name: "BankReconciliationReminderPayment",
    element: <BankReconciliationReminderPayment />,
  },
  {
    path: "/admin/bankReconciliationReminderReceipt",

    name: "BankReconciliationReminderReceipt",
    element: <BankReconciliationReminderReceipt />,
  },
  {
    path: "/admin/paymentVouchers",

    name: "PaymentVoucher",
    element: <PaymentVoucher />,
  },
  {
    path: "/admin/receiptVoucher",

    name: "ReceiptVoucher",
    element: <ReceiptVoucher />,
  },
  {
    path: "/admin/paymentRegister",

    name: "PaymentRegister",
    element: <PaymentRegister />,
  },
  {
    path: "/admin/receiptRegister",

    name: "ReceiptRegister",
    element: <ReceiptRegister />,
  },
  {
    path: "/admin/accountLedgerReport",

    name: "AccountLedgerReport",
    element: <AccountLedgerReport />,
  },
  {
    path: "/admin/groupReport",

    name: "GroupReport",
    element: <GroupReport />,
  },
  {
    path: "/admin/voucherDetails",

    name: "VoucherDetail",
    element: <VoucherDetail />,
  },
  {
    path: "/admin/profitAndLoss",

    name: "ProfitAndLoss",
    element: <ProfitAndLoss />,
  },
  {
    path: "/admin/scheduledForProfitAndLoss",

    name: "ScheduledForProfitAndLoss",
    element: <ScheduledForProfitAndLoss />,
  },
  {
    path: "/admin/balanceSheet",

    name: "BalanceSheet",
    element: <BalanceSheet />,
  },
  {
    path: "/admin/scheduledForBalanceSheet",

    name: "ScheduledForBalanceSheet",
    element: <ScheduledForBalanceSheet />,
  },
  {
    path: "/admin/trialBalance",

    name: "TrialBalance",
    element: <TrialBalance />,
  },
  {
    path: "/admin/scheduledTrialBalance",

    name: "ScheduledTrialBalance",
    element: <TrialBalance />,
  },
  {
    path: "/admin/department",

    name: "Department",
    element: <Department />,
  },
  {
    path: "/admin/maritalStatus",

    name: "MaritalStatus",
    element: <MaritalStatus />,
  },
  {
    path: "/admin/deductionType",

    name: "DeductionType",
    element: <DeductionType />,
  },
  {
    path: "/admin/leaveType",

    name: "LeaveType",
    element: <LeaveType />,
  },
  {
    path: "/admin/employeeDocuments",

    name: "EmployeeDocuments",
    element: <EmployeeDocuments />,
  },
  {
    path: "/admin/linkingAccount",

    name: "LinkingAccount",
    element: <LinkingAccount />,
  },
  {
    path: "/admin/journalVouchers",

    name: "JournalVoucher",
    element: <JournalVoucher />,
  },
  // {
  // 	path: "/admin/employeeBank",
  //
  // 	name: "EmployeeBankDetails",
  // 	element: EmployeeBankDetails,
  // },
  {
    path: "/admin/employeeFamilyDetails",

    name: "EmployeeFamilyDetails",
    element: <EmployeeFamilyDetails />,
  },
  {
    path: "/admin/overTime",

    name: "OverTime",
    element: <OverTime />,
  },
  {
    path: "/admin/employeeSettlement",

    name: "EmployeeSettlement",
    element: <EmployeeSettlement />,
  },
  {
    path: "/admin/employeeDeduction",

    name: "EmployeeDeduction",
    element: <EmployeeDeduction />,
  },
  {
    path: "/admin/loan",

    name: "Loan",
    element: <Loan />,
  },
  {
    path: "/admin/leave",

    name: "Leave",
    element: <Leave />,
  },
  {
    path: "/admin/resign",

    name: "Resign",
    element: <Resign />,
  },
  {
    path: "/admin/salaryStatement",

    name: "SalaryStatement",
    element: <SalaryStatement />,
  },
  {
    path: "/admin/employeeCommissions",

    name: "EmployeeCommissions",
    element: <EmployeeCommissions />,
  },
  {
    path: "/admin/invoiceReceipt",
    name: "InvoiceReceipt",
    element: <InvoiceReceipt />,
  },
  {
    path: "/admin/invoiceReceipt",
    name: "InvoiceReceipt",
    element: <InvoiceReceipt />,
  },
  {
    path: "/admin/invoiceReceipt/view/:invoiceId",
    name: "InvoiceReceiptView",
    element: <InvoiceReceiptView />,
  },
  {
    path: "/admin/invoiceReceipt/:id",
    name: "InvoiceReceiptDetails",
    element: <InvoiceReceiptDetails />,
  },
  ...expenseRoutes,
  ...categoryRoutes,
  ...journalEntryRoutes,
  ...productRoutes,
  ...purchaseOrderRoutes,
  ...purchaseReturnRoutes,
  ...purchaseReceiptRoutes,
  ...invoiceRoutes,
  ...invoiceReceiptRoutes,
  ...supplierRoutes,
  ...bankRoutes,
  ...groupRoutes,
  ...accountGroupRoutes,
  ...accountLedgerRoutes,
  ...membershipPackageRoutes,
  ...trainingPackageRoutes,
  ...dietPlanPackageRoutes,
  ...workoutRoutes,
  ...workoutCategoriesRoutes,
  ...memberShipFreezingDateRoutes,
  ...sessionRoutes,
  ...salesReturnRoutes,
  ...lockerRoutes,
  ...nutritionPlanRoutes,
  ...userRoutes,
  ...employeeRoutes,
  ...balanceSheetRoutes,
  ...profitAndLossRoutes,
  ...mealRoutes,
  ...branchRoutes,
  ...foodRoutes,
  ...classRoutes,
  // ...bookedClassRoutes,
  ...customersRoutes,
  ...linkingAccountRoutes,
  // ...dietPlanPackageBookingsRoutes,
  // ...personalTrainingPackageBookingRoutes,
  // ...membershipPackageBookingRoutes,
  ...lockerMemberRoutes,
  ...orderRoutes,
  ...trackNutritionPlanRoutes,
  ...classScheduledRoutes,
  ...notificationRoutes,
  ...voucherDetailsRoutes,
  ...postponeClassRoute,
  ...classWorkoutRoutes,
  ...memberWorkoutRoutes,
  ...employeeAttendanceRoutes,
  ...memberAttendanceRoutes,
  ...classMemberAttendanceRoutes,
  ...coreDataRoutes,
  ...employeeSettlementRoutes,
  ...employeeOvertimeRoutes,
  ...deductionTypeRoutes,
  ...departmentRoutes,
  ...employeeDeductionRoutes,
  ...maritalStatusRoutes,
  ...leaveTypeRoutes,
  ...employeeBonusRoutes,
  ...employeeLoanRoutes,
  ...employeeLeaveRoutes,
  ...classTrainerAttendanceRoutes,
  ...sessionAttendanceRoutes,
  ...sessionWorkoutRoutes,
  ...employeeDocumentsRoutes,
  ...employeeBankRoutes,
  ...employeeFamilyRoutes,
  // ...BodyMeasurementTracksRoutes,
  ...NotificationTemplateRoutes,
];

// const Routes = [

// { path: "/admin/log",  name: "Log", element: Log },

// { path: "/admin/setting",  name: "setting", element: Terms },
// {
//   path: "/admin/setting/terms",
//
//   name: "setting",
//   element: Terms,
// },
// {
//   path: "/admin/setting/privacy-policy",
//
//   name: "Privacy-Policy",
//   element: Policy,
// },

// {
//   path: "/admin/setting/about-us",
//
//   name: "About-Us",
//   element: AboutUs,
// },

// {
//   path: "/admin/attendances",
//
//   name: "Attendances",
//   element: Attendances,
// },

// {
//   path: "/admin/employeeAttendances",
//
//   name: "EmployeeAttendances",
//   element: EmployeeAttendances,
// },

// {
//   path: "/admin/dietPlanPackages",
//
//   name: "DietPlanPackages",
//   element: DietPlanPackages,
// },

// {
// 	path: "/admin/personalTrainingPackage",
//
// 	name: "PersonalTrainingPackage",
// 	element: PersonalTrainingPackage,
// },
// {
//   path: "/admin/membershipPackages",
//
//   name: "MembershipPackages",
//   element: MembershipPackages,
// },

// {
//   path: "/admin/packageBookings",
//
//   name: "PackageBookings",
//   element: PackageBookings,
// },

// // {
// // 	path: "/admin/dietPlanPackageBookings",
// //
// // 	name: "DietPlanPackageBookings",
// // 	element: DietPlanPackageBookings,
// // },

// {
//   path: "/admin/paymentHistory",
//
//   name: "PaymentHistory",
//   element: PaymentHistory,
// },

// {
//   path: "/admin/discount",
//
//   name: "Discount",
//   element: Discount,
// },

// { path: "/admin/workOut",  name: "WorkOut", element: WorkOut },

// // { path: "/admin/classes",  name: "Classes", element: Classes },

// // {
// // 	path: "/admin/scheduleClasses",
// //
// // 	name: "ScheduleClasses",
// // 	element: ScheduleClasses,
// // },

// {
//   path: "/admin/bookingClasses",
//
//   name: "BookingClasses",
//   element: BookingClasses,
// },

// { path: "/admin/foods",  name: "Foods", element: Foods },

// {
// 	path: "/admin/nutritionPlan",
//
// 	name: "NutritionPlan",
// 	element: NutritionPlan,
// },

// {
// 	path: "/admin/trackNutritionPlan",
//
// 	name: "TrackNutritionPlan",
// 	element: TrackNutritionPlan,
// },

// {
//   path: "/admin/allBodyMeasurementTracks",
//
//   name: "AllBodyMeasurementTracks",
//   element: AllBodyMeasurementTracks,
// },

// { path: "/admin/locker",  name: "Locker", element: Locker },

// {
// 	path: "/admin/lockerMember",
//
// 	name: "LockerMember",
// 	element: LockerMember,
// },
// {
//   path: "/admin/lockerTrack",
//
//   name: "LockerTrack",
//   element: LockerTrack,
// },

// { path: "/admin/session",  name: "Session", element: Session },

// {
//   path: "/admin/memberAttendances",
//
//   name: "MemberAttendances",
//   element: MemberAttendances,
// },

// // {
// // 	path: "/admin/sessionAttendances",
// //
// // 	name: "SessionAttendances",
// // 	element: SessionAttendances,
// // },

// {
//   path: "/admin/trainerClasses",
//
//   name: "TrainerClasses",
//   element: TrainerClasses,
// },
// // {
// // 	path: "/admin/personalTrainingPackageBookings",
// //
// // 	name: "personalTrainingPackageBookings",
// // 	element: PersonalTrainingPackageBookings,
// // },
// // {
// // 	path: "/admin/membershipPackageBookings",
// //
// // 	name: "MembershipPackageBookings",
// // 	element: MembershipPackageBookings,
// // },
// // {
// // 	path: "/admin/mealTypes",
// //
// // 	name: "MealTypes",
// // 	element: MealTypes,
// // },
// // {
// // 	path: "/admin/suppliers",
// //
// // 	name: "Suppliers",
// // 	element: Suppliers,
// // },
// // {
// // 	path: "/admin/notification",
// //
// // 	name: "Notification",
// // 	element: Notification,
// // },
// // {
// // 	path: "/admin/purchaseOrders",
// //
// // 	name: "PurchaseOrders",
// // 	element: PurchaseOrders,
// // },
// {
//   path: "/admin/purchaseReturns",
//
//   name: "PurchaseReturns",
//   element: PurchaseReturns,
// },
// {
//   path: "/admin/purchaseReceipts",
//
//   name: "PurchaseReceipts",
//   element: PurchaseReceipts,
// },
// // {
// // 	path: "/admin/salesInvoices",
// //
// // 	name: "Invoices",
// // 	element: Invoices,
// // },
// {
//   path: "/admin/salesReceipts",
//
//   name: "Receipts",
//   element: Receipts,
// },
// {
//   path: "/admin/salesReturns",
//
//   name: "SalesReturns",
//   element: SalesReturns,
// },
// // {
// // 	path: "/admin/customers",
// //
// // 	name: "Customers",
// // 	element: Customers,
// // },
// {
//   path: "/admin/UnitOfMeasure",
//
//   name: "UnitOfMeasure",
//   element: UOMList,
// },
// {
//   path: "/admin/UnitOfMeasure/create",
//
//   name: "Create Product UnitOfMeasure",
//   element: CreateProductUom,
// },
// {
//   path: "/admin/UnitOfMeasure/update/:id",
//
//   name: "Update Product UnitOfMeasure",
//   element: CreateProductUom,
// },
// // {
// // 	path: "/admin/products",
// //
// // 	name: "Products",
// // 	element: Products,
// // },
// // {
// // 	path: "/admin/products/(create|update)/:id?",
// //
// // 	name: "Products Create",
// // 	element: ProductsCreate,
// // },
// // {
// // 	path: "/admin/categories",
// //
// // 	name: "Categories",
// // 	element: Categories,
// // },
// {
//   path: "/admin/productsWithUOMStock",
//
//   name: "ProductsWithUOMStock",
//   element: ProductsWithUOMStock,
// },
// {
//   path: "/admin/bank",
//
//   name: "Bank",
//   element: Bank,
// },
// {
//   path: "/admin/group",
//
//   name: "Group",
//   element: Group,
// },
// {
//   path: "/admin/accountGroup",
//
//   name: "AccountGroup",
//   element: AccountGroup,
// },
// {
//   path: "/admin/accountLedger",
//
//   name: "AccountLedger",
//   element: AccountLedger,
// },
// {
//   path: "/admin/bankReconciliationReminderPayment",
//
//   name: "BankReconciliationReminderPayment",
//   element: BankReconciliationReminderPayment,
// },
// {
//   path: "/admin/bankReconciliationReminderReceipt",
//
//   name: "BankReconciliationReminderReceipt",
//   element: BankReconciliationReminderReceipt,
// },
// {
//   path: "/admin/paymentVouchers",
//
//   name: "PaymentVoucher",
//   element: PaymentVoucher,
// },
// {
//   path: "/admin/receiptVoucher",
//
//   name: "ReceiptVoucher",
//   element: ReceiptVoucher,
// },
// {
//   path: "/admin/paymentRegister",
//
//   name: "PaymentRegister",
//   element: PaymentRegister,
// },
// {
//   path: "/admin/receiptRegister",
//
//   name: "ReceiptRegister",
//   element: ReceiptRegister,
// },
// {
//   path: "/admin/accountLedgerReport",
//
//   name: "AccountLedgerReport",
//   element: AccountLedgerReport,
// },
// {
//   path: "/admin/groupReport",
//
//   name: "GroupReport",
//   element: GroupReport,
// },
// {
//   path: "/admin/voucherDetails",
//
//   name: "VoucherDetail",
//   element: VoucherDetail,
// },
// {
// 	path: "/admin/profitAndLoss",
//
// 	name: "ProfitAndLoss",
// 	element: ProfitAndLoss,
// },
// {
// 	path: "/admin/scheduledForProfitAndLoss",
//
// 	name: "ScheduledForProfitAndLoss",
// 	element: ScheduledForProfitAndLoss,
// },
// {
// 	path: "/admin/balanceSheet",
//
// 	name: "BalanceSheet",
// 	element: BalanceSheet,
// },
// {
// 	path: "/admin/scheduledForBalanceSheet",
//
// 	name: "ScheduledForBalanceSheet",
// 	element: ScheduledForBalanceSheet,
// },
// {
//   path: "/admin/trialBalance",
//
//   name: "TrialBalance",
//   element: TrialBalance,
// },
// {
//   path: "/admin/scheduledTrialBalance",
//
//   name: "ScheduledTrialBalance",
//   element: TrialBalance,
// },
// {
//   path: "/admin/department",
//
//   name: "Department",
//   element: Department,
// },
// {
//   path: "/admin/maritalStatus",
//
//   name: "MaritalStatus",
//   element: MaritalStatus,
// },
// {
//   path: "/admin/deductionType",
//
//   name: "DeductionType",
//   element: DeductionType,
// },
// {
//   path: "/admin/leaveType",
//
//   name: "LeaveType",
//   element: LeaveType,
// },
// {
//   path: "/admin/employeeDocuments",
//
//   name: "EmployeeDocuments",
//   element: EmployeeDocuments,
// },
// {
//   path: "/admin/linkingAccount",
//
//   name: "LinkingAccount",
//   element: LinkingAccount,
// },
// {
//   path: "/admin/journalVouchers",
//
//   name: "JournalVoucher",
//   element: JournalVoucher,
// },
// // {
// // 	path: "/admin/employeeBank",
// //
// // 	name: "EmployeeBankDetails",
// // 	element: EmployeeBankDetails,
// // },
// {
//   path: "/admin/employeeFamilyDetails",
//
//   name: "EmployeeFamilyDetails",
//   element: EmployeeFamilyDetails,
// },
// {
//   path: "/admin/overTime",
//
//   name: "OverTime",
//   element: OverTime,
// },
// {
//   path: "/admin/employeeSettlement",
//
//   name: "EmployeeSettlement",
//   element: EmployeeSettlement,
// },
// {
//   path: "/admin/employeeDeduction",
//
//   name: "EmployeeDeduction",
//   element: EmployeeDeduction,
// },
// {
//   path: "/admin/loan",
//
//   name: "Loan",
//   element: Loan,
// },
// {
//   path: "/admin/leave",
//
//   name: "Leave",
//   element: Leave,
// },
// {
//   path: "/admin/resign",
//
//   name: "Resign",
//   element: Resign,
// },
// {
//   path: "/admin/salaryStatement",
//
//   name: "SalaryStatement",
//   element: SalaryStatement,
// },
// {
//   path: "/admin/employeeCommissions",
//
//   name: "EmployeeCommissions",
//   element: EmployeeCommissions,
// },
// ...expenseRoutes,
// ...categoryRoutes,
// ...journalEntryRoutes,
// ...productRoutes,
// ...purchaseOrderRoutes,
// ...purchaseReturnRoutes,
// ...purchaseReceiptRoutes,
// ...invoiceRoutes,
// ...invoiceReceiptRoutes,
// ...supplierRoutes,
// ...bankRoutes,
// ...groupRoutes,
// ...accountGroupRoutes,
// ...accountLedgerRoutes,
// ...membershipPackageRoutes,
// ...trainingPackageRoutes,
// ...dietPlanPackageRoutes,
// ...workoutRoutes,
// ...workoutCategoriesRoutes,
// ...memberShipFreezingDateRoutes,
// ...sessionRoutes,
// ...salesReturnRoutes,
// ...lockerRoutes,
// ...nutritionPlanRoutes,
// ...userRoutes,
// ...employeeRoutes,
// ...balanceSheetRoutes,
// ...profitAndLossRoutes,
// ...mealRoutes,
// ...branchRoutes,
// ...foodRoutes,
// ...classRoutes,
// ...bookedClassRoutes,
// ...customersRoutes,
// ...linkingAccountRoutes,
// ...dietPlanPackageBookingsRoutes,
// ...personalTrainingPackageBookingRoutes,
// ...membershipPackageBookingRoutes,
// ...lockerMemberRoutes,
// ...orderRoutes,
// ...trackNutritionPlanRoutes,
// ...classScheduledRoutes,
// ...membersRoutes,
// ...notificationRoutes,
// ...voucherDetailsRoutes,
// ...postponeClassRoute,
// ...classWorkoutRoutes,
// ...memberWorkoutRoutes,
// ...employeeAttendanceRoutes,
// ...memberAttendanceRoutes,
// ...classMemberAttendanceRoutes,
// ...coreDataRoutes,
// ...employeeSettlementRoutes,
// ...employeeOvertimeRoutes,
// ...deductionTypeRoutes,
// ...departmentRoutes,
// ...employeeDeductionRoutes,
// ...maritalStatusRoutes,
// ...leaveTypeRoutes,
// ...employeeBonusRoutes,
// ...employeeLoanRoutes,
// ...employeeLeaveRoutes,
// ...classTrainerAttendanceRoutes,
// ...sessionAttendanceRoutes,
// ...sessionWorkoutRoutes,
// ...employeeDocumentsRoutes,
// ...employeeBankRoutes,
// ...employeeFamilyRoutes,
// ...BodyMeasurementTracksRoutes,
// ...NotificationTemplateRoutes,
// ...MemberRoutes,
// ];

// export default Routes;
